<template>
    <div>
        <b-modal
            v-model="showModal" 
            title="Novo Usuário" 
            @shown="onModalShown"
            size="lg"
            centered
            hide-footer 
        >
            <el-form 
                :model="payload" 
                ref="userStoreForm" 
                label-position="top" 
                status-icon 
                :rules="rules"
            > 
                <el-row :gutter="12">
                    <!-- Usuario ativo -->
                    <el-col>
                        <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <el-button :type="payload.status ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                    <i class="fas fa-user-lock"></i>
                                </el-button>
                                <h6 class="mb-0 font-weight-bold">Usuário {{ payload.status ? 'Ativo' : 'Inativo' }}</h6>
                            </div>

                            <el-form-item prop="status" class="mb-0">
                                <el-switch 
                                    v-model="payload.status"
                                    active-text="Ativo"
                                    inactive-text="Inativo"
                                />
                            </el-form-item>
                        </div>
                    </el-col>

                    <!-- Nome -->
                    <el-col :span="12">
                        <el-form-item prop="nome">
                            <label>Nome</label>
                            <el-input
                                v-model="payload.nome" 
                                placeholder="Nome do usuário"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- E-mail -->
                    <el-col :span="12">
                        <el-form-item prop="email">
                            <label>E-mail</label>
                            <el-input
                                v-model="payload.email" 
                                placeholder="E-mail do usuário"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Perfil do usuario -->
                    <el-col :span="12">
                        <el-form-item prop="tipo_usuario">
                            <label>Perfil do Usuário</label>
                            <el-select
                                v-model="payload.tipo_usuario"
                                placeholder="Perfil do usuário"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="role in roles"
                                    :key="role.tipo"
                                    :label="role.text"
                                    :value="role.tipo"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Representante -->
                    <el-col v-if="representersFiltred.length > 0" :span="12">
                        <el-form-item prop="representante_codigo">
                            <label>{{ representerTitle }}</label>
                            <el-select
                                v-model="payload.representante_codigo"
                                placeholder="Representante"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="representer in representersFiltred"
                                    :key="representer.value"
                                    :label="representer.text"
                                    :value="representer.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Representante para tipo preposto -->
                    <el-col v-if="payload.tipo_usuario === 'preposto'" :span="12">
                        <el-form-item prop="representante_preposto">
                            <label>Representante do Preposto</label>
                            <el-select
                                v-model="payload.representante_preposto"
                                placeholder="Representante"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="representer in representersPrepoFiltred"
                                    :key="representer.value"
                                    :label="representer.text"
                                    :value="representer.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                    <!-- Centro de Distr -->
                    <el-col v-if="payload.tipo_usuario !== 'preposto'">
                        <el-form-item prop="centro_distribuicao">
                            <label>Centro de distribuição</label>
                            <el-select
                                v-model="payload.centro_distribuicao"
                                placeholder="Centro de distribuição"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="center in centers"
                                    :key="center.value"
                                    :label="center.text"
                                    :value="center.codigo"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col>
                        <el-row :gutter="12">
                            <!-- Senha -->
                            <el-col :span="12">
                                <el-form-item prop="password">
                                    <label>Senha</label>
                                    <el-input
                                        type="password"
                                        v-model="payload.password" 
                                        placeholder="Digite a nova senha"
                                        :disabled="isLoading"
                                        autocomplete="off"
                                        show-password
                                    />
                                </el-form-item>
                            </el-col>
        
                            <!-- Confirmar Senha -->
                            <el-col :span="12">
                                <el-form-item prop="password_confirmation">
                                    <label>Confirmar senha</label>
                                    <el-input
                                        type="password"
                                        v-model="payload.password_confirmation" 
                                        placeholder="Confirme a nova senha"
                                        :disabled="isLoading"
                                        autocomplete="off"
                                        show-password
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>

                    <!-- Regional Farma -->
                    <el-col v-if="payload.tipo_usuario === 'gerente_regional'">
                        <el-form-item prop="regional_farma">
                            <label>Regional Farma</label>
                            <el-select
                                v-model="payload.regional_farma"
                                placeholder="Selecione a regional"
                                :disabled="isLoading"
                            >
                                <el-option
                                    v-for="regional in regionaisFarma"
                                    :key="regional"
                                    :label="regional"
                                    :value="regional"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Classes atendidas -->
                    <el-col>
                        <el-form-item prop="classes_atendidas">
                            <label>Classes atendidas</label>
                            <el-select
                                v-model="payload.classes_atendidas"
                                multiple
                                placeholder="Todas as classes"
                                :disabled="isLoading"
                                clearable
                            >
                                <el-option
                                    v-for="classe in classesDistribuidor"
                                    :key="classe.value"
                                    :label="classe.label"
                                    :value="classe.value"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Regiao da retencao (meta fixa na tela de Retencao) -->
                    <el-col>
                        <el-form-item prop="regiao_retencao">
                            <label>Região da retenção</label>
                            <el-select
                                v-model="payload.regiao_retencao"
                                placeholder="Nenhuma (vê todas)"
                                :disabled="isLoading"
                                clearable
                            >
                                <el-option
                                    v-for="regiao in regioesRetencao"
                                    :key="regiao"
                                    :label="'Região ' + regiao"
                                    :value="regiao"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    type="danger"
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    plain
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                >
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                    Salvar
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </b-modal>
    </div>
</template>
<script>
    // Components
    import {
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Card,
        Empty,
        Notification,
        Form, 
        FormItem,
        Select,
        Option,
        Switch,
    } from "element-ui";

    // Schema
    import { validateEmail, validatePass, validateMatchPass } from "@/schemas/generalSchema"
    import { validateRepresenter, validateRepresenterPrepo } from "@/schemas/userSchema"

    //Api
    import { UserApi } from "@/api/User/UserApi";
    import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const userApi = new UserApi();
    const centroDistApi = new CentroDistribuicaoApi();
    const generalResourcesApi = new GeneralResourcesApi();

    const TIPOS_USUARIOS_POR_REPRESENTANTE = {
        representante: ['representante_varejo', 'gerente_regional', 'gerente_distrital', 'analista_farma'],
        gestor: ['gestor'],
        preposto: ['preposto'],
        gerente: ['gerente_varejo', 'gerente_nacional', 'diretor_nacional']
    }

    const CLASSES_DISTRIBUIDOR = [
        { value: 'G', label: 'Classe Gestora' },
        { value: 'A', label: 'Classe Master' },
        { value: 'V', label: 'Classe Varejo' },
        { value: 'L', label: 'Classe L' },
        { value: 'F', label: 'Classe Farma' },
        { value: 'J', label: 'Classe J' },
        { value: 'P', label: 'Classe P' },
    ]

    const REGIONAIS_FARMA = ['SP', 'RJ/ES/CO', 'MG/MT', 'N/NE', 'RS/SC/MS/PR']

    export default {
        data() {
            return {
                payload: {
                    nome: null,
                    email: null,
                    tipo_usuario: "",
                    status: true,
                    password: null,
                    password_confirmation: null,
                    centro_distribuicao: null,
                    representante_codigo: null,
                    representante_preposto: null,
                    classes_atendidas: [],
                    regional_farma: null,
                    regiao_retencao: null,
                },
                showModal: false,
                isLoading: false,
                roles: [],
                centers: [],
                representers: [],
                classesDistribuidor: CLASSES_DISTRIBUIDOR,
                regionaisFarma: REGIONAIS_FARMA,
                regioesRetencao: ['1', '2', '3', '4', '5', '6', '7'],
                rules: {
                    nome: [
                        { required: true, message: 'O nome é obrigatório' }
                    ],
                    email: [
                        { required: true, message: 'O email é obrigatório' },
                    ],
                    tipo_usuario: [
                        { required: true, message: 'É necessário selecionar um perfil' }
                    ],
                    regional_farma: [
                        { required: true, message: 'Selecione a regional' }
                    ],
                    representante_codigo: [],
                    representante_preposto: [],
                    centro_distribuicao: [
                        { required: true, message: 'É necessário selecionar um centro de distribuição' },
                    ],
                    password: [
                        { required: true, message: 'Por favor digite a nova senha' },
                    ],
                    password_confirmation: [
                        { required: true, message: 'Por favor digite a senha novamente' },
                    ],
                },
            }
        },
        computed: {
            tiposRepresentantePermitidos() {
                return Object.entries(TIPOS_USUARIOS_POR_REPRESENTANTE)
                    .filter(([, tiposUsuario]) =>
                        tiposUsuario.includes(this.payload.tipo_usuario)
                    )
                    .map(([tipoRepresentante]) => tipoRepresentante)
            },
            representersFiltred() {
                return this.representers.filter(representer =>
                    this.tiposRepresentantePermitidos.includes(representer.tipo)
                )
            },
            representersPrepoFiltred() {
                if (this.payload.tipo_usuario) {
                    return this.representers.filter(representer => representer.tipo == "representante")
                }
                
                return []
            },
            representerTitle() {
                const titles = ['Representante', 'Gestor', 'Preposto', 'Gerente']

                return titles.filter(title =>
                    this.tiposRepresentantePermitidos.includes(title.toLowerCase())
                )[0];
            }
        },  
        methods: {
            onSubmit() {
                this.$refs.userStoreForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;

                    await userApi.store(this.payload)
                        .then(() => {
                            Notification.success({
                                title: 'Sucesso',
                                message: 'O Usuário foi criado com sucesso!'
                            });
                        }).catch((error) => {
                            if (error?.response.status == 422) {
                                if (error?.response?.data.errors) {
                                    error.response.data.errors.forEach(err_message => {
                                        Notification.warning({
                                            title: 'Atenção',
                                            message: err_message
                                        });
                                    });
                                }
                                return
                            }

                            Notification.error({
                                title: 'Erro',
                                message: 'Não foi possível criar o usuário!'
                            });
                        }).finally(() => {
                            this.isLoading = false;
                            this.toggleModal();
                            this.resetForm();
                        });
                })
            },
            /** Funções */
            async getRoles() {
                try {
                    const res = await userApi.roles()

                    this.roles = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as funções dos usuários!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /** Centros de distribuição */
            async getCenters() {
                try {
                    const res = await centroDistApi.pluck()

                    this.centers = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os centros de distribução!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /** Representantes */
            async getRepresenters(){
                try {
                    const res = await userApi.pluckRepresenters()

                    this.representers = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os representantes!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.userStoreForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.userStoreForm.resetFields();
            },
        },
        watch: {
            'payload.tipo_usuario': function (_newValue, _oldValue) {
                if(_newValue !== _oldValue) {
                    this.payload.representante_codigo = null;
                    this.payload.representante_preposto = null;
                    this.payload.regional_farma = null;
                }

                if(_newValue == 'preposto') {
                    this.payload.centro_distribuicao = null
                }
            }
        },
        mounted() {
            this.getRoles();
            this.getCenters();
            this.getRepresenters();
        },
        created() {
            this.rules.email.push({ validator: validateEmail(this.payload), trigger: 'blur' })
            this.rules.representante_codigo.push({ validator: validateRepresenter(this.payload), trigger: 'change' })
            this.rules.representante_preposto.push({ validator: validateRepresenterPrepo(this.payload), trigger: 'change' })
            this.rules.password.push({ validator: validatePass(this.payload), trigger: 'blur' })
            this.rules.password_confirmation.push({validator: validateMatchPass(this.payload), trigger: 'blur' })
        },
        components: {
            [Message.name]: Message,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.name]: Dialog,
            [Card.name]: Card,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [Switch.name]: Switch,
            [Dialog.name]: Dialog,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/User/UserCreateModal.vue